var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMotor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21 2L6.205 0H4V1H5.795L6.795 2H2.75C1.5 2 0.5 3 0.5 4.25C0.5 5.5 1.5 6.5 2.75 6.5C3.86 6.5 4.78 5.69 4.96 4.635L6.02 4C6 4.085 6 4.165 6 4.25C6 5.5 7 6.5 8.25 6.5C9.5 6.5 10.5 5.5 10.5 4.25C10.5 3 9.5 2 8.25 2H8.21ZM3.92 4.63C3.75 5.135 3.29 5.5 2.735 5.5C2.40348 5.5 2.08554 5.3683 1.85112 5.13388C1.6167 4.89946 1.485 4.58152 1.485 4.25C1.485 3.91848 1.6167 3.60054 1.85112 3.36612C2.08554 3.1317 2.40348 3 2.735 3C3.295 3 3.75 3.37 3.92 3.875H2.5V4.625L3.92 4.63ZM8.235 5.5C7.90348 5.5 7.58554 5.3683 7.35112 5.13388C7.1167 4.89946 6.985 4.58152 6.985 4.25C6.985 3.91848 7.1167 3.60054 7.35112 3.36612C7.58554 3.1317 7.90348 3 8.235 3C8.56652 3 8.88446 3.1317 9.11888 3.36612C9.3533 3.60054 9.485 3.91848 9.485 4.25C9.485 4.58152 9.3533 4.89946 9.11888 5.13388C8.88446 5.3683 8.56652 5.5 8.235 5.5Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotor);
export default __webpack_public_path__ + "static/media/icon-motor.af25f7c324eda87e620cf03d25c32614.svg";
export { ForwardRef as ReactComponent };